import messages from '../../../../locale/messages';
import { inputTextLimit } from '../../../../helpers/textRestriction';

const validate = values => {

  const errors = {}

  if (!values?.smtpName || values?.smtpName.toString().trim() == "") {
    errors.smtpName = messages.required;
  } else if (values?.smtpName?.length > inputTextLimit) {
    errors.smtpName = messages.inputFieldRestriction;
  }

  if (!values?.smtpHost || values?.smtpHost.toString().trim() == "") {
    errors.smtpHost = messages.required;
  } else if (values?.smtpHost?.length > inputTextLimit) {
    errors.smtpHost = messages.inputFieldRestriction;
  }

  if (!values?.smtpPort || values?.smtpPort.toString().trim() == "") {
    errors.smtpPort = messages.required;
  } else if (values?.smtpPort?.length > inputTextLimit) {
    errors.smtpPort = messages.inputFieldRestriction;

  }

  if (!values?.smtpEmail || values?.smtpEmail.toString().trim() == "") {
    errors.smtpEmail = messages.required;
  } else if (values?.smtpEmail?.length > inputTextLimit) {
    errors.smtpEmail = messages.inputFieldRestriction;
  }

  if (!values?.smtpSender || values?.smtpSender.toString().trim() == "") {
    errors.smtpSender = messages.required;
  } else if (values?.smtpSender?.length > inputTextLimit) {
    errors.smtpSender = messages.inputFieldRestriction;
  }

  if (!values?.smtpSenderEmail) {
    errors.smtpSenderEmail = messages.required && messages.required;
  } else if (!values?.isEncrypt && !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,6}$/i.test(values?.smtpSenderEmail)) {
    errors.smtpSenderEmail = messages.emailInvalid && messages.emailInvalid;
  }

  if (!values?.smtpPassword || values?.smtpPassword.toString().trim() == "") {
    errors.smtpPassword = messages.required;
  } else if (values?.smtpPassword?.length > inputTextLimit) {
    errors.smtpPassword = messages.inputFieldRestriction;
  }

  return errors
}

export default validate
